import { render, staticRenderFns } from "./promoBanner.vue?vue&type=template&id=37183884&scoped=true"
import script from "./promoBanner.vue?vue&type=script&lang=js"
export * from "./promoBanner.vue?vue&type=script&lang=js"
import style0 from "./promoBanner.vue?vue&type=style&index=0&id=37183884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37183884",
  null
  
)

export default component.exports